// @core/api/endpoints/workflow/resume_execution.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  PipelineExecutionResponse,
  ResumeExecutionRequest,
} from '../../../types/workflow';

const BASE_PATH = '/workflow';

/**
 * Resume execution
 * Resumes a paused pipeline execution. Optionally provides input data (approval decision, form submission) that is passed to the suspended node. Publishes to workflow.execution.started so the engine picks it up.
 */
export async function ResumeExecution(
  execution_id: string,
  data: ResumeExecutionRequest,
  options?: RequestOptions
): Promise<PipelineExecutionResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/workflows/executions/:execution_id/resume`;
  requestPath = requestPath.replace(':execution_id', encodeURIComponent(execution_id));
  const requestOptions = options;
  return client.post<PipelineExecutionResponse>(requestPath, data, requestOptions);
}
